import api from "@/config/apiConfig"

class PlanController {
  async index() {
    const response = await api.get("/plans");
    return response.data;
  }

  async create(req) {
    const response = await api.post("/plans", req);
    return response.data;
  }

  async update(req) {
    const response = await api.put(`/plans/${req.id}`, req);
    return response.data;
  }

  async reactivate(id) {
    const response = await api.post(`/plans/${id}/reactivate`);
    return response.data;
  }

  async delete(id) {
    const response = await api.delete(`/plans/${id}`);
    return response.data;
  }

  async companies(id) {
    const response = await api.get(`/plans/${id}/companies`);
    return response.data;
  }
}

export default new PlanController();
